import React from 'react'
import './Header.css'
import HeaderImg from '../../img/headerImg.png'
import btnPlayStore from '../../img/btn-playstore.png'
import btnAppStore from '../../img/btn-appstore.png'
const Header = () => {
  return (
   <div className="header">
     <div className="left-header">
       <p className='header-info'>All-in-one Business Manager 🔥</p>
       <h3>Easy Keep track of all your sales, income and inventory</h3>
       <p>Take your business to the next level with Hishabee Business Manager Mobile App.</p>
       <div className="btn-download-group">
          <div className="btn-playstore">
              <img src={btnPlayStore} alt="" />
          </div>
          <div className="btn-appstore">
              <img src={btnAppStore} alt="" />
          </div>
          <div className="btn-appstore"></div>
       </div>
     </div>
     <div className="right-header">
       <div className="header-img-container">
         <img src={HeaderImg} alt="header-img" />
       </div>
     </div>
   </div>
  )
}

export default Header